import TopicTwo from "../../../components/platform-contents/meta-trader-4-mobile-contents/TopicTwo";

const MetaTrader4MobileContentFive = () => {
  return (
    <>
      {/* <TopicTwo /> */}

      <div className="how__work__platform">
        <div className="quality-section-market">
          <div className="quality-header-market">
            <h1>Why Choose MetaTrader 4 Mobile with The Pips</h1>
            <p>
              The Pips enhances the world’s most recognized trading platform
              with next-level accessibility, performance, and personalized
              learning support.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="contact__cards row">
            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Global Accessibility</h4>
                </div>
                <p>
                  Monitor markets, open trades, and close positions on the go,
                  anytime, anywhere.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Reliable Performance</h4>
                </div>
                <p>
                  Experience low-latency trading and minimal downtime, even
                  during peak market volatility.
                </p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-12 mb-4">
              <div className="contact__card">
                <div className="card-header">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/images/markets/instant_withdrawals.png"
                    }
                    alt="play icon"
                  />
                  <h4>Learning Integration</h4>
                </div>
                <p>
                  Gain real-world experience through in-app guides, tips, and
                  strategy insights curated by The Pips’ experts.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MetaTrader4MobileContentFive;
